export const SIMULATORS = {
  "louer-vendre": {
    slug: "louer-vendre",
    title: "Continuer à louer ou vendre ?",
    endpoint: "/simulate/louer-vendre",
    cta: "Voir le résultat",
    steps: [
      {
        title: "Le bien",
        subtitle: "Renseignez la valeur, le prix d'achat et le loyer.",
        fields: [
          { key: "valeurBien", label: "Valeur / prix de vente estimé", suffix: "€", placeholder: "250 000" },
          { key: "prixAcquisition", label: "Prix d'acquisition", suffix: "€", placeholder: "200 000", help: "Prix payé à l'achat, frais de notaire inclus (sert au calcul de la plus-value)." },
          { key: "loyerMensuel", label: "Loyer mensuel perçu (charges comprises)", suffix: "€", placeholder: "950" },
          { key: "fraisGestionPct", label: "Frais de gestion locative", suffix: "%", placeholder: "0", help: "% des loyers (0 si vous gérez vous-même)." },
          { key: "chargesAnnuelles", label: "Charges annuelles (charges locatives incluses)", suffix: "€", placeholder: "2 400", help: "Taxe foncière, copropriété, assurance, entretien." },
        ],
      },
      {
        title: "Le financement",
        subtitle: "Où en êtes-vous de votre crédit ?",
        fields: [
          { key: "creditRestant", label: "Capital restant dû", suffix: "€", placeholder: "120 000" },
          { key: "mensualite", label: "Mensualité de crédit", suffix: "€", placeholder: "780" },
          { key: "tauxCredit", label: "Taux du crédit", suffix: "%", placeholder: "1,8" },
        ],
      },
      {
        title: "Projection & hypothèses",
        subtitle: "Votre horizon et les hypothèses de comparaison.",
        fields: [
          { key: "appreciationAnnuelle", label: "Appréciation annuelle du bien", suffix: "%", placeholder: "2" },
          { key: "dureeDetention", label: "Années de détention déjà écoulées", suffix: "ans", placeholder: "8", help: "Depuis quand possédez-vous le bien ? (abattements plus-value)." },
          { key: "horizon", label: "Horizon de projection", suffix: "ans", placeholder: "10" },
          { key: "tauxImposition", label: "Taux d'imposition (TMI)", suffix: "%", placeholder: "30", default: "30" },
          { key: "tauxPlacement", label: "Taux de placement alternatif", suffix: "%", placeholder: "2,5", default: "2,5", help: "Rendement si vous vendez et placez l'argent ailleurs." },
        ],
      },
    ],
  },
  "coloc-simple": {
    slug: "coloc-simple",
    title: "Colocation ou location simple ?",
    endpoint: "/simulate/coloc-simple",
    cta: "Voir le résultat",
    steps: [
      {
        title: "Location simple",
        subtitle: "Si vous louez le bien à un seul locataire.",
        fields: [
          { key: "loyerSimpleMensuel", label: "Loyer mensuel (charges comprises)", suffix: "€", placeholder: "900" },
          { key: "chargesSimpleMensuelles", label: "Charges mensuelles", suffix: "€", placeholder: "120", help: "Copropriété, électricité, etc. payées par le propriétaire." },
          { key: "tauxVacanceSimple", label: "Vacance locative", suffix: "%", placeholder: "3", default: "3", help: "Part de l'année sans locataire." },
          { key: "honorairesSimplePct", label: "Honoraires de gestion", suffix: "%", placeholder: "0", default: "0", help: "% des loyers (0 si vous gérez vous-même)." },
        ],
      },
      {
        title: "Colocation",
        subtitle: "Si vous louez chambre par chambre.",
        fields: [
          { key: "loyerParChambreMensuel", label: "Loyer par chambre (charges comprises)", suffix: "€", placeholder: "450" },
          { key: "nombreChambres", label: "Nombre de chambres", suffix: "", placeholder: "3" },
          { key: "chargesColocMensuelles", label: "Charges mensuelles", suffix: "€", placeholder: "250", help: "Copropriété, électricité, internet, assurance, etc." },
          { key: "tauxVacanceColoc", label: "Vacance locative", suffix: "%", placeholder: "10", default: "10" },
          { key: "honorairesColocPct", label: "Honoraires de gestion (colocation)", suffix: "%", placeholder: "0", default: "0", help: "% des loyers (peut différer de la location simple)." },
        ],
      },
    ],
  },
  "cash-flow": {
    slug: "cash-flow",
    title: "Quel cash-flow pour votre investissement ?",
    endpoint: "/simulate/cash-flow",
    cta: "Voir le résultat",
    steps: [
      {
        title: "Les recettes",
        subtitle: "Vos revenus locatifs mensuels.",
        fields: [
          { key: "loyerHorsCharges", label: "Loyers hors charges", suffix: "€", placeholder: "800" },
          { key: "provisionsCharges", label: "Provisions pour charges", suffix: "€", placeholder: "100", default: "0", help: "Charges récupérables appelées au locataire chaque mois." },
          { key: "chargesAdditionnelles", label: "Charges additionnelles facturées", suffix: "€", placeholder: "0", default: "0", help: "Autres charges refacturées au locataire, le cas échéant." },
          { key: "joursVacance", label: "Durée de vacance locative", suffix: "j/an", placeholder: "20", default: "20", help: "Nombre de jours sans locataire par an." },
        ],
      },
      {
        title: "Les dépenses",
        subtitle: "Vos charges et votre crédit.",
        fields: [
          { key: "mensualiteEmprunt", label: "Mensualité de crédit", suffix: "€", placeholder: "650" },
          { key: "gestionLocativePct", label: "Gestion locative", suffix: "%", placeholder: "0", default: "0", help: "% appliqué sur les revenus encaissés (loyers + charges)." },
          { key: "chargesCopro", label: "Charges de copropriété", suffix: "€", placeholder: "360", period: true, periodDefault: "trimestrielle" },
          { key: "travauxEntretien", label: "Petits travaux d'entretien", suffix: "€", placeholder: "500", default: "0", period: true, periodDefault: "annuelle" },
          { key: "taxeFonciere", label: "Taxe foncière", suffix: "€", placeholder: "900", period: true, periodDefault: "annuelle" },
          { key: "autresCharges", label: "Autres charges", suffix: "€", placeholder: "0", default: "0", period: true, periodDefault: "annuelle", help: "Assurance PNO, garantie loyers impayés, etc." },
        ],
      },
    ],
  },
  "tri-rendement": {
    slug: "tri-rendement",
    title: "TRI ou rendement locatif ?",
    endpoint: "/simulate/tri-rendement",
    cta: "Voir le résultat",
    steps: [
      {
        title: "Le bien",
        subtitle: "Prix, loyer et charges de votre investissement.",
        fields: [
          { key: "prixAcquisition", label: "Prix d'acquisition (frais inclus)", suffix: "€", placeholder: "215 000", help: "Prix payé, frais de notaire et d'agence compris." },
          { key: "fraisAcquisitionPct", label: "Dont frais d'acquisition", suffix: "%", placeholder: "7,5", default: "7,5", help: "Part des frais dans le prix (7,5 % = forfait légal)." },
          { key: "loyerMensuel", label: "Loyer mensuel", suffix: "€", placeholder: "900" },
          { key: "chargesAnnuelles", label: "Charges annuelles", suffix: "€", placeholder: "2 400", help: "Taxe foncière, copropriété, gestion, assurance, entretien." },
        ],
      },
      {
        title: "Le financement",
        subtitle: "Votre apport et les conditions du crédit.",
        fields: [
          { key: "apport", label: "Apport personnel", suffix: "€", placeholder: "30 000" },
          { key: "tauxCredit", label: "Taux du crédit", suffix: "%", placeholder: "3,5" },
          { key: "dureeCredit", label: "Durée du crédit", suffix: "ans", placeholder: "20", default: "20" },
        ],
      },
      {
        title: "La revente",
        subtitle: "Votre horizon et vos hypothèses d'évolution.",
        fields: [
          { key: "horizon", label: "Horizon de revente", suffix: "ans", placeholder: "10", default: "10" },
          { key: "revalorisationPct", label: "Revalorisation annuelle du bien", suffix: "%", placeholder: "2", default: "2" },
          { key: "indexationLoyersPct", label: "Indexation annuelle des loyers", suffix: "%", placeholder: "1,5", default: "1,5", help: "Charges indexées au même rythme." },
          { key: "fraisRevientePct", label: "Frais de revente", suffix: "%", placeholder: "5", default: "5", help: "Frais d'agence ou diagnostics à la charge du vendeur." },
        ],
      },
    ],
  },
};
